import { useEffect } from 'react'

/**
 * Custom hook to dynamically update the favicon
 * @param iconUrl - URL of the favicon image
 */
export const useFavicon = (iconUrl: string) => {
  useEffect(() => {
    if (!iconUrl) return

    // Find existing favicon link element by ID first, then by rel attribute
    let faviconLink = document.querySelector('#favicon') as HTMLLinkElement || 
                     document.querySelector('link[rel="icon"]') as HTMLLinkElement
    
    // If no favicon link exists, create one
    if (!faviconLink) {
      faviconLink = document.createElement('link')
      faviconLink.rel = 'icon'
      faviconLink.id = 'favicon'
      document.head.appendChild(faviconLink)
    }
    
    // Update the favicon URL
    faviconLink.href = iconUrl
    
  }, [iconUrl])
}